"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _InputError = _interopRequireDefault(require("./InputError"));
var _InputHelpText = _interopRequireDefault(require("./InputHelpText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const FormInputImage = props => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-12 align-bottom col-sm-".concat(props.divColSize)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container p-0"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "form-group row border-bottom py-2"
  }, props.value && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("label", {
    className: "col-4",
    htmlFor: props.name
  }, props.label), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-4 text-center"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: props.value,
    border: "2",
    width: "100",
    className: "img-fluid mb-2",
    alt: ""
  }), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("a", {
    href: props.value,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "btn btn-success"
  }, "View Image"), " ", /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-danger",
    onClick: props.onDeleteFile
  }, "Delete Image")), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-4"
  }, /*#__PURE__*/_react.default.createElement("input", {
    id: props.name,
    name: props.name,
    type: "file",
    className: (0, _classnames.default)({
      "is-invalid": props.error
    }),
    onChange: props.onChange,
    "aria-describedby": props.name + "Help",
    placeholder: props.placeholder
  }))), !props.value && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("label", {
    className: "col-4",
    htmlFor: props.name
  }, props.label), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-8"
  }, /*#__PURE__*/_react.default.createElement("input", {
    id: props.name,
    name: props.name,
    type: "file",
    className: (0, _classnames.default)({
      "is-invalid": props.error
    }),
    onChange: props.onChange,
    "aria-describedby": props.name + "Help",
    placeholder: props.placeholder
  }))), /*#__PURE__*/_react.default.createElement(_InputError.default, {
    error: props.error
  }), /*#__PURE__*/_react.default.createElement(_InputHelpText.default, {
    helpText: props.helpText
  }))));
};
var _default = FormInputImage;
exports.default = _default;